import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import styled from "styled-components";

const DefaultSuccessContent = styled.div`
  padding: 0;

  ${TertiaryHeader} {
    margin-bottom: 16px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    padding: 0;

    ${TertiaryHeader} {
      margin-top: 16px;
    }
  }
`;

export default DefaultSuccessContent;
